import { t } from 'i18next';
import { ControlledAutocompleteDropdownLazy } from 'src/shared/components/form/controlledAutocompleteDropdownLazy';
import ConsoleHelper from 'src/shared/functions/consoleHelper';
import { useIsMounted } from 'src/shared/hooks/useIsMounted';
import { getResCause } from 'src/shared/services/formSettingService';

export const MemberAdvancedSearchResCause = () => {
  const isMounted = useIsMounted();

  return (
    <ControlledAutocompleteDropdownLazy
      name='resCause'
      componentWidth='100%'
      callback={(x) => ConsoleHelper.log(x, 'snurre')}
      fetchMethod={async () => {
        try {
          const result = await getResCause();
          if (isMounted()) {
            const items = result.data.results[0].extraOptions.filter((x) => x.name !== '');
            return items;
          }
        } catch (e) {
          if (isMounted()) {
            ConsoleHelper.log(e);
          }
        }

        return [];
      }}
      nameProp='name'
      label={t('member:memberAdvancedSearch.resCause')}
    />
  );
};
